import React, { useState, useEffect, useCallback } from 'react'
import useInterval from 'hooks/common/useInterval'
import Presenter from 'components/presenters/signup/PhoneSMSAuthScene'
import ScenePaginationFooter from 'components/presenters/footer/ScenePaginationFooter'
import { format, sub, set } from 'date-fns'
import server from 'server/serverController2'

export default function PhoneSMSAuthScene({
  initPhone,
  currSceneNum,
  totalSceneNum,
  onComplete,
  onError,
}) {
  const [startCounting, setStartCounting] = useState(false)
  const [expireTime, setExpireTime] = useState(set(new Date(), { minutes: 3, seconds: 0 }))
  const [resetExpireTime, setResetExpireTime] = useState(false)
  const [validPhoneNum, setValidPhoneNum] = useState(false)
  const [validFooterBtn, setValidFooterBtn] = useState(false)

  const [phoneNum, setPhoneNum] = useState('')
  const [verificationCode, setVerificationCode] = useState('')
  const [messageSent, setMessageSent] = useState(false)

  useEffect(() => {
    if (initPhone) {
      setPhoneNum(initPhone)
    }
  }, [initPhone])
  useEffect(() => {
    setMessageSent(false)
    if (phoneNum.length > 9) {
      setValidPhoneNum(true)
    } else {
      setValidPhoneNum(false)
    }
  }, [phoneNum])
  useEffect(() => {
    if (resetExpireTime === true) {
      setExpireTime(set(new Date(), { minutes: 3, seconds: 0 }))
      setResetExpireTime(false)
    }
  }, [resetExpireTime])
  useEffect(() => {
    if (messageSent === true && verificationCode.length === 6) {
      setValidFooterBtn(true)
    } else {
      setValidFooterBtn(false)
    }
  }, [messageSent, verificationCode])

  useInterval(() => {
    if (expireTime && startCounting === true && format(expireTime, 'mm:ss') !== '00:00') {
      const updatedDate = sub(new Date(expireTime), { seconds: 1 })

      setExpireTime(updatedDate)
    }
  }, 1000)

  const requestSMSAuth = useCallback(() => {
    setResetExpireTime(true)
    setStartCounting(true)

    server.postRequestData(`auth/phone`, { phone: phoneNum }, (res) => {
      try {
        if (res?.success !== 1) {
          setValidFooterBtn(false)
          if (onError) {
            onError(res['error']['res_data'])
          }
          return
        }
        setMessageSent(true)
      } catch (err) {
        console.log(err)
      }
    })
  }, [onError, phoneNum])

  const submitVerifyCode = useCallback(() => {
    server.postRequestData(
      `auth/phone/code`,
      { phone: phoneNum, code: verificationCode },
      (res) => {
        try {
          if (res?.success !== 1) {
            setValidFooterBtn(false)
            if (onError) {
              onError(res['error']['res_data'])
            }
            return
          }
          const jsonData = res['data']
          if (onComplete) {
            const result = jsonData['updated_item']
            onComplete(result)
          }
        } catch (err) {
          console.log(err)
        }
      },
    )
  }, [onComplete, onError, phoneNum, verificationCode])

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Presenter
        startCounting={startCounting}
        expireTime={format(expireTime, 'mm:ss')}
        onReqSMSAuth={requestSMSAuth}
        phoneNum={phoneNum}
        validPhoneNum={validPhoneNum}
        onChangePhoneNum={(newNum) => {
          if (newNum.length < 12) {
            setPhoneNum(newNum)
          }
        }}
        verificationCode={verificationCode}
        onChangeCode={(code) => {
          if (code.length < 7) {
            setVerificationCode(code)
          }
        }}
      />
      <ScenePaginationFooter
        currSceneNum={currSceneNum}
        totalSceneNum={totalSceneNum}
        valid={validFooterBtn}
        onComplete={() => {
          submitVerifyCode()
        }}
      />
    </div>
  )
}
